import { CardMedia, Icon, Typography, useMediaQuery } from '@mui/material'
import { Box } from '@mui/system'
import StatusBar from 'components/reusable/statusBar/AdxStatusBar'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import UpskillTable from 'pages/approval-center/components/UpskillTable'
import React, { useState } from 'react'
import { useQuery } from 'react-query'
import { useLocation, useNavigate } from 'react-router'
import { getOneUpskillProgression } from 'services/api/modules/upskill/approval-center'
import UpskillHeader from './UpskillHeader'
import AdxSortTable from 'components/reusable/table/AdxSortTable'
import ProgressionDrawer from './ProgressionDrawer'

const OneUpskillProgression = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const isLarge = useMediaQuery((theme) => theme.breakpoints.up('lg'))
  const { id } = location.state

  const [drawerState, setDrawerState] = useState({ right: false })
  const [data, setData] = useState(null)

  const getStatus = (value) => {
    switch (true) {
      case value === 0 || value === null:
        return 'upcoming'
      case value === 100:
        return 'completed'
      default:
        return 'ongoing'
    }
  }

  const tableColumn = [
    {
      id: 1,
      Header: 'Enrolled Courses',
      accessor: 'course_name',
      Cell: (props) => {
        const { value } = props

        const roundeOfNumber = (num) => {
          return Math.round(num)
        }

        return (
          <Box display="flex" alignItems="center">
            {props?.row?.original?.course_logo ? (
              <CardMedia
                component="img"
                sx={{
                  marginRight: 2,
                  height: 45,
                  width: 45,
                  objectFit: 'cover',
                  borderRadius: '50%',
                }}
                src={props?.row?.original?.course_logo}
              />
            ) : (
              <Box
                width={45}
                height={45}
                borderRadius="50%"
                bgcolor="alternate.light"
                marginRight={2}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Icon
                  sx={{
                    color: 'alternate.main',
                  }}
                >
                  text_snippet
                </Icon>
              </Box>
            )}

            <Box
              sx={{
                width: '100%',
                display: 'flex',
                flexDirection: isLarge ? 'column' : 'row',
                justifyContent: 'space-between',
                alignItems: isLarge ? 'flex-start' : 'center',
              }}
            >
              <Box>
                <Typography variant={isLarge ? 'body1' : 'body2'}>{value}</Typography>
                {!isLarge && (
                  <Box display="flex" alignItems="center" mt={1}>
                    <StatusBar status={getStatus(props?.row?.original?.progress?.total)} />
                  </Box>
                )}
              </Box>
              <Icon
                sx={{
                  fontSize: 30,
                  color: 'light-gray-text.main',
                  display: isLarge ? 'none' : 'block',
                }}
              >
                chevron_right
              </Icon>

              {/* <Box display="flex" alignItems="center" columnGap={1}>
                <Icon sx={{ fontSize: 7, color: 'light-gray-text.main' }}>circle</Icon>
                <Typography variant="body2" color="light-gray-text.main">
                  Next Class: Wed, 20/02/2024
                </Typography>
              </Box> */}
              {isLarge && (
                <Box sx={{ width: '100%' }} display="flex" alignItems="center" gap={'8px'}>
                  <Box
                    sx={{
                      width: '100%',
                      position: 'relative',
                      height: '10px',
                      backgroundColor: 'gray-background.main',
                      borderRadius: '4.5px',
                    }}
                  >
                    <Box
                      sx={{
                        width: `${
                          props?.row?.original?.progress?.total
                            ? roundeOfNumber(props?.row?.original?.progress?.total)
                            : '0'
                        }%`,
                        position: 'absolute',
                        height: '100%',
                        backgroundColor: 'alternate.main',
                        borderRadius: '4.5px',
                      }}
                    />
                  </Box>
                  <Typography sx={{ width: '40px' }} variant="subtitle1" color="alternate.main">
                    {props?.row?.original?.progress?.total
                      ? props?.row?.original?.progress?.total
                      : '0'}
                    %
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
        )
      },
    },
    {
      id: 2,
      Header: 'Status',
      accessor: 'progress.total',
      Cell: (props) => {
        const { value } = props

        return (
          <Box display="flex" justifyContent="center" alignItems="center">
            <StatusBar status={getStatus(value)} sx={{ width: '150px' }} />
          </Box>
        )
      },
    },
  ]

  // pagination if needed
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const { isLoading: upskillProgressionDataIsLoading, data: upskillProgressionData } = useQuery(
    ['oneUpskillProgressionData', id],
    async () => {
      const { data } = await getOneUpskillProgression(id)
      return data
    },
    {
      refetchOnWindowFocus: false,
    }
  )

  const name = upskillProgressionData?.staff_details?.staff_name
  const designation = upskillProgressionData?.staff_details?.designation
  const profile_picture = upskillProgressionData?.staff_details?.staff_profile_image

  const handleDrawer = (anchor, open) => (item) => {
    setDrawerState({ ...drawerState, [anchor]: open })
    setData({ profile_picture, name, designation, ...item })
  }

  // const changePage = (item) => {
  //   navigate(`/app/appraisal-cycle/upskill-progression/${id}/${item.course_name}`, {
  //     state: {
  //       profile_picture,
  //       name,
  //       designation,
  //       course_name: item.course_name,
  //       progress_data: item.progress,
  //     },
  //   })
  // }

  return (
    <React.Fragment>
      <DashboardContainer>
        {isLarge && (
          <Box display="flex" alignItems="center" mb={3}>
            <Typography
              onClick={() => navigate(-1)}
              color="alternate.main"
              sx={{ cursor: 'pointer' }}
            >
              Upskill Progression
            </Typography>
            <Icon sx={{ fontSize: 20, color: 'light-gray-text.main' }}>chevron_right</Icon>
            <Typography color="light-gray-text.main" textTransform="capitalize">
              {name}
            </Typography>
          </Box>
        )}
        <UpskillHeader
          name={name}
          designation={designation}
          profile_picture={profile_picture}
          isLoading={upskillProgressionDataIsLoading}
        />
        <AdxSortTable
          column={isLarge ? tableColumn : tableColumn.splice(0, 1)}
          data={upskillProgressionData?.courses?.data ?? []}
          nav={isLarge ? 'View' : null}
          sxNav={{ textDecoration: 'underline' }}
          onClick={handleDrawer('right', true)}
          divClick
          sx={{
            boxShadow: 'none',
            borderRadius: '0 0 4.5px 4.5px',
            border: '1px solid #E5E5E5',
          }}
          pagination
          count={upskillProgressionData?.courses?.meta?.total}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        {/* <UpskillTable
          column={tableColumn}
          data={upskillProgressionData?.courses?.data ?? []}
          nav="View"
          onClick={changePage}
          sxHeader
          sxNav
          sxCell
          error={upskillProgressionDataIsError}
          isLoading={upskillProgressionDataIsLoading}
          type={'staff course'}
          lastPage={upskillProgressionData?.courses?.meta?.last_page}
          count={upskillProgressionData?.courses?.meta?.total}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        /> */}
      </DashboardContainer>
      <ProgressionDrawer drawerState={drawerState} handleDrawer={handleDrawer} data={data} />
    </React.Fragment>
  )
}
export default OneUpskillProgression
